import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-informe-inicio-gestion',
  templateUrl: './informe-inicio-gestion.component.html',
  styleUrls: ['./informe-inicio-gestion.component.css']
})
export class InformeInicioGestionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
